module.exports = __webpack_public_path__ + "img/531fa6820e90460b9f82e84c7f20d6e4.0c498b8d.jpg";